import styled from '@emotion/styled'

export const InvoicesPeriodSelector = styled.div`
  margin-left: auto;
`
